const listeners = new Set();

export const setAlertModal = config => {
   listeners.forEach(listener => listener({ type: 'SHOW', ...config }));
};

export const resetAlertModal = id => {
   listeners.forEach(listener => listener({ type: 'HIDE', id }));
};

export const clearAlertModals = () => {
   listeners.forEach(listener => listener({ type: 'CLEAR' }));
};

export const subscribe = listener => {
   listeners.add(listener);
   return () => listeners.delete(listener);
};
